import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CONTACT, INCLUDED, NOT_AVAILABLE } from '../../data/additionalCosts';
type CostCellProps = {
  value: string;
  accentClass: string;
};
export function CostCell({
  value,
  accentClass
}: CostCellProps) {
  if (value === INCLUDED) {
    return <span className={`inline-flex items-center gap-1.5 text-sm font-bold ${accentClass}`} data-id="element-15" data-mp="2o3quvnxe6r1p">
        <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-16" data-mp="323rr2q2ppaau" />
        Included
      </span>;
  }
  if (value === NOT_AVAILABLE) {
    return <>
        <span className="text-sm text-brand-gray" aria-hidden="true" data-id="element-17" data-mp="2x344qhpfhhmy">
          —
        </span>
        <span className="sr-only" data-id="element-18" data-mp="3bvxncbzzydvu">Not Available</span>
      </>;
  }
  if (value === CONTACT) {
    return <a href="#/contact" className="text-sm font-medium text-brand-gray underline underline-offset-2 transition-colors duration-150 ease-out hover:text-brand-red focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red" data-id="element-19" data-mp="3kuj01qiseyop">
        Contact Us
      </a>;
  }
  return <span className="text-sm font-semibold text-brand-black" data-id="element-20" data-mp="3dqvq8cvokpch">{value}</span>;
}